/**
 * @generated SignedSource<<4130d2e69b1c79a1d91a474e7093f5df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type v2RecommendedForYouSponsorArticleQueueItemsEdge$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"homeNativeArticleContentItemContent">;
  };
  readonly " $fragmentType": "v2RecommendedForYouSponsorArticleQueueItemsEdge";
};
export type v2RecommendedForYouSponsorArticleQueueItemsEdge$key = {
  readonly " $data"?: v2RecommendedForYouSponsorArticleQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"v2RecommendedForYouSponsorArticleQueueItemsEdge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "v2RecommendedForYouSponsorArticleQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeNativeArticleContentItemContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "8c7320a149f0369db470d5e2d964a88a";

export default node;
